import { ReactElement, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { confirm as originalConfirm } from "react-confirm-box";
import { Options } from "react-confirm-box/dist/types";

const defaultOptions = {
  render: (
    message: string,
    onConfirm: () => void,
    onCancel: () => void
  ): any => {
    return (
      <KendoDialog
        message={message}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    );
  },
};

interface KendoDialogProps {
  readonly message: string;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

function KendoDialog({
  message,
  onConfirm,
  onCancel,
}: KendoDialogProps): ReactElement {
  const [visible, setVisible] = useState(true);
  const toggleDialog = () => {
    setVisible(!visible);
  };

  return visible ? (
    <Dialog title="Please confirm" closeIcon={false}>
      <p
        style={{
          margin: "25px",
          textAlign: "center",
        }}
      >
        {message}
      </p>
      <DialogActionsBar>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          onClick={() => {
            toggleDialog();
            onCancel();
          }}
        >
          No
        </button>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          onClick={() => {
            toggleDialog();
            onConfirm();
          }}
        >
          Yes
        </button>
      </DialogActionsBar>
    </Dialog>
  ) : (
    <div />
  );
}

export const confirm = (message: string, options?: Options | undefined) =>
  originalConfirm(message, { ...defaultOptions, ...options });
